import type { FC } from 'react';

import { IconName } from '@catalyze/ui';

import { ContactContainer } from '../ContactContainer';
import { ContactIcon } from '../ContactIcon';
import { IconButton } from '../ContactPhones/styled';
import { ContactSubtitle } from '../ContactSubtitle';
import { ContactTitle } from '../ContactTitle';

interface IContactLine {
    addressFirstLine: string;
    addressSecondLine: string;
    contactUsed: string;
    onClick: () => void;
}

export const ContactAddress: FC<IContactLine> = ({
    addressFirstLine,
    addressSecondLine,
    contactUsed,
    onClick,
}) => (
    <ContactContainer>
        <IconButton type="button" onClick={onClick}>
            <ContactIcon
                icon={IconName.MAP_PIN}
                contacted={contactUsed.length > 0}
            />
        </IconButton>
        <div>
            <ContactTitle>{addressFirstLine}</ContactTitle>
            <ContactSubtitle>{addressSecondLine}</ContactSubtitle>
            <ContactSubtitle>{contactUsed}</ContactSubtitle>
        </div>
    </ContactContainer>
);
